import { render, staticRenderFns } from "./CarfaxModelCorrectionModal.vue?vue&type=template&id=ea7fb25e"
import script from "./CarfaxModelCorrectionModal.vue?vue&type=script&lang=js"
export * from "./CarfaxModelCorrectionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports